import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockWarehouseFormFieldsFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  file: File
  config: Partial<HttpClientConfig>
}

export function uploadToOpenDockStorageFactory({
  repository,
}: GetOpenDockWarehouseFormFieldsFactoryDependencies) {
  return async function uploadToOpenDockStorage({ shipmentUUID, file, config }: Params) {
    try {
      return await repository.uploadToOpenDockStorage(shipmentUUID, file, config)
    } catch (error) {
      throw new Error('Could not get OpenDock warehouse details', { cause: error as Error })
    }
  }
}

export function uploadToOpenDockStorage({ shipmentUUID, file, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newUploadToOpenDockStorage = uploadToOpenDockStorageFactory({
    repository,
  })
  return newUploadToOpenDockStorage({ shipmentUUID, file, config })
}
